import { IFormattedStaffPick } from '@ifit/gateway-wolf-dashboard-service';
import { UseQueryResult } from 'react-query';
import { useStaffPicks } from './use-staff-picks';

export function useFeaturedNowItems(): UseQueryResult<IFormattedStaffPick[], Error> {
  const queryResult = useStaffPicks();
  queryResult.data = queryResult.data?.filter((pick) => pick.type === 'workout' || pick.type === 'program');
  return queryResult;
}
